import {
  ADS_TABLE,
  ADS_TRENDS,
  EMAILS_TABLE,
  EMAILS_TRENDS,
  JOURNEYS_TABLE,
  JOURNEYS_TRENDS,
  OTT_TABLE,
  OTT_TRENDS,
  QUICK_LINKS_TABLE,
  QUICK_LINKS_TRENDS,
  SUMMARY_TABLE,
  SUMMARY_TRENDS,
} from '../../../../../../shared/constants/analytics/contexts';
import {
  ALL_DATA_VALUE,
  JOURNEYS_VALUE,
  OTT_VALUE,
  QUICK_LINKS_VALUE,
  UNIVERSAL_ADS_VALUE,
  UNIVERSAL_EMAIL_VALUE,
} from '../../../../../../shared/constants/summary';
import type { ProductType } from '../../../../../../shared/types/summary.types';
import {
  ANALYTICS_ENDPOINT_BY_CONTEXT,
  ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT,
} from '../../../constants/analytics/endpoints';

export const PRODUCT_TRENDS_ENDPOINT_MAPPING: Record<ProductType, string> = {
  [ALL_DATA_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[SUMMARY_TRENDS],
  [JOURNEYS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[JOURNEYS_TRENDS],
  [QUICK_LINKS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[QUICK_LINKS_TRENDS],
  [UNIVERSAL_ADS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[ADS_TRENDS],
  [UNIVERSAL_EMAIL_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[EMAILS_TRENDS],
  [OTT_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[OTT_TRENDS],
};

export const PRODUCT_REPORT_ENDPOINT_MAPPING: Record<ProductType, string> = {
  [ALL_DATA_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[SUMMARY_TABLE],
  [JOURNEYS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[JOURNEYS_TABLE],
  [QUICK_LINKS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[QUICK_LINKS_TABLE],
  [UNIVERSAL_ADS_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[ADS_TABLE],
  [UNIVERSAL_EMAIL_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[EMAILS_TABLE],
  [OTT_VALUE]: ANALYTICS_ENDPOINT_BY_CONTEXT[OTT_TABLE],
};

export const PRODUCT_REPORT_TOTALS_ENDPOINT_MAPPING: Record<ProductType, string> = {
  [ALL_DATA_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[SUMMARY_TABLE],
  [JOURNEYS_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[JOURNEYS_TABLE],
  [QUICK_LINKS_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[QUICK_LINKS_TABLE],
  [UNIVERSAL_ADS_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[ADS_TABLE],
  [UNIVERSAL_EMAIL_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[EMAILS_TABLE],
  [OTT_VALUE]: ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT[OTT_TABLE],
};
